import { apiClient } from './client'
import type {
  LearningConfigurationV2,
  ContentLearningConfigurationDto,
  EffectiveConfigurationV2Response,
} from '@/types/configurationV2'

const BASE = '/api/configurations/v2'

// ===== Content-Configuration Mappings =====

export async function getContentMappings(): Promise<ContentLearningConfigurationDto[]> {
  const res = await apiClient.get(`${BASE}/content-mappings`)
  return res.data.data
}

export async function getContentMapping(contentId: number): Promise<ContentLearningConfigurationDto | null> {
  const res = await apiClient.get(`${BASE}/content-mappings/${contentId}`)
  return res.data.data
}

export async function setContentMapping(
  contentId: number,
  learningConfigurationId: number
): Promise<ContentLearningConfigurationDto> {
  const res = await apiClient.put(`${BASE}/content-mappings/${contentId}`, {
    learningConfigurationId,
  })
  return res.data.data
}

export async function deleteContentMapping(contentId: number): Promise<void> {
  await apiClient.delete(`${BASE}/content-mappings/${contentId}`)
}

// ===== Product Configuration Mode =====

export async function setProductConfigMode(
  productId: number,
  mode: 'default' | 'single_template' | 'per_hierarchy',
  templateId?: number
): Promise<void> {
  await apiClient.put(`${BASE}/product/${productId}/mode`, { mode, templateId })
}

// ===== v2 Product Configuration CRUD =====

export async function getProductConfigurationV2(
  productId: number
): Promise<LearningConfigurationV2 | null> {
  const res = await apiClient.get(`${BASE}/product/${productId}`)
  return res.data.data ?? null
}

export async function setProductConfigurationV2(
  productId: number,
  config: LearningConfigurationV2
): Promise<void> {
  await apiClient.put(`${BASE}/product/${productId}`, config)
}

// ===== Effective Configuration =====

export async function getEffectiveConfigurationV2(params: {
  productId: number
  contentId?: number
  level?: string
}): Promise<EffectiveConfigurationV2Response> {
  const res = await apiClient.get(`${BASE}/effective`, { params })
  return res.data.data
}
